import * as primitives from './primitives/web/primitives.js';
import * as mobile from './primitives/react-native/primitives.native.js';
export default primitives;
export { mobile, primitives };